import 'angular';

import '../../app-lite/app.module.ajs';

import { CoreStates }          from './core.states.ajs';

import { CoreCtrl }             from './core';
import { CoreConfirmationCtrl } from './core.confirmation';


angular.module('app.core', [
  'app-lite'
]).config(CoreStates)
  .controller('CoreConfirmationCtrl', CoreConfirmationCtrl)
  .controller('CoreCtrl', CoreCtrl);
